export default __webpack_public_path__ + "a351d04209c52ec87ff23b25549fa5a9.png";